<template>
    <component :is="tag" :class="classes" :style="styles">{{ text }}</component>
</template>

<script>
import './text-element.scss';

export default {
    name: 'TextElement',
    __editor: {
        fields: {
            text: {
                widget: 'textarea',
            },
            tag: {
                widget: 'select',
                values: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'small'],
            },
            appearance: {
                widget: 'select',
                values: ['auto', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'small'],
            },
            color: {
                widget: 'select',
                values: ['primary', 'secondary', 'body', 'white'],
            },
            align: {
                widget: 'select',
                values: ['auto', 'center', 'left', 'right', 'justify'],
            },
            verticalMargin: {
                widget: 'slider',
                values: {
                    min: 0,
                    max: 6,
                    step: 0.125,
                },
            },
        },
    },
    props: {
        text: {
            type: String,
            default: 'Text',
        },
        tag: {
            type: String,
            default: 'p',
            validator: function(val) {
                return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'small'].includes(val);
            },
        },
        appearance: {
            type: String,
            default: 'auto',
            validator: function(val) {
                return ['auto', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'small'].includes(val);
            },
        },
        align: {
            type: String,
            default: 'auto',
        },
        color: {
            type: String,
            default: 'body',
            validator: function(val) {
                return ['primary', 'secondary', 'body', 'white'].includes(val);
            },
        },
        verticalMargin: {
            type: Number,
            default: 1,
        },
        bold: {
            type: Boolean,
            default: false,
        },
        italic: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classes() {
            return [
                'scc-text-element',
                `scc-text-element--${this.color}`,
                `scc-text-element--text-align-${this.align}`,
                {
                    'scc-text-element--bold': this.bold,
                    'scc-text-element--italic': this.italic,
                    [this.appearance]: this.appearance !== 'auto',
                },
            ];
        },
        styles() {
            return { margin: `${this.verticalMargin * 16}px 0` };
        },
    },
};
</script>
